import { Link } from "react-router-dom";

export default function LegalPage({ type = "terms" }) {
  const isTerms = type === "terms";

  return (
    <div className="min-h-screen bg-[#F8F6F1] text-[#0A1628]">
      <div className="max-w-4xl mx-auto px-6 md:px-10 py-16">
        <Link
          to="/"
          className="inline-flex items-center text-sm text-[#0A1628]/70 hover:text-[#0A1628] mb-8"
        >
          ← Volver a la landing
        </Link>

        <div className="mb-10">
          <p className="text-xs uppercase tracking-[0.2em] text-[#8A7B5D] mb-3">
            DSA | Economía Digital
          </p>
          <h1
            className="text-4xl md:text-5xl font-semibold tracking-tight mb-4"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            {isTerms ? "Términos y Condiciones" : "Política de Privacidad"}
          </h1>
          <p className="text-base md:text-lg text-[#0A1628]/75 leading-relaxed">
            {isTerms
              ? "Condiciones básicas de uso e información comercial de esta página."
              : "Tratamiento básico de los datos enviados por formularios y contacto."}
          </p>
        </div>

        <div className="space-y-8 text-sm md:text-base leading-7 text-[#0A1628]/85">
          {isTerms ? (
            <>
              <section>
                <h2 className="text-xl font-semibold mb-3">1. Rol de DSA</h2>
                <p>
                  DSA actúa como canal de orientación, captación,
                  precalificación y acompañamiento comercial.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">
                  2. Proveedor educativo
                </h2>
                <p>
                  El programa educativo referido en esta página es provisto por
                  MINED.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">
                  3. Finalidad de la información
                </h2>
                <p>
                  La información presentada en esta página tiene fines
                  informativos y de evaluación comercial.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">4. Resultados</h2>
                <p>
                  Los resultados dependen de múltiples factores, incluyendo
                  contexto, dedicación y ejecución individual.
                </p>
              </section>
            </>
          ) : (
            <>
              <section>
                <h2 className="text-xl font-semibold mb-3">
                  1. Datos recopilados
                </h2>
                <p>
                  Los datos enviados mediante formularios o canales de contacto
                  podrán incluir nombre, correo, WhatsApp y otra información
                  necesaria para la orientación comercial.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">
                  2. Uso de la información
                </h2>
                <p>
                  DSA utilizará estos datos para contacto informativo,
                  evaluación comercial, seguimiento y orientación sobre la
                  oferta educativa consultada.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">
                  3. Alcance del tratamiento
                </h2>
                <p>
                  La información será utilizada dentro del proceso de atención,
                  precalificación y seguimiento comercial relacionado con la
                  consulta realizada.
                </p>
              </section>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
